import React from 'react';
import {injectIntl} from "react-intl";

import './SADropdown.css';

class SADropdown extends React.Component {

  render() {
    const {intl:{formatMessage}, name, choices = [], error, onChange, ...attributes} = this.props;
    const {value} = this.props;
    const options = choices.map(choice => <option key={choice.value} value={choice.value}>{choice.display}</option>);


    const className = this.props.disabled ? "fc-state-disabled" : "";

    return (
      <div className={error && error[name] ? " error":''}>
        <select className={`${className}`} name={name} id={name} value={value} onChange={onChange} style={{width: '100%'}} {...attributes}>
          {options}
        </select>
        {error && error[name] && (
          <span className='txt-error'>{formatMessage({id: error[name].message}, {value: error[name].args[0]})}</span>
        )}
      </div>
    );
  }

}

export default injectIntl(SADropdown);



// WEBPACK FOOTER //
// ./src/components/common/dropdown/SADropdown.js